import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Services } from '../components/Services';
import { TargetGroups } from '../components/TargetGroups';
import { CTA } from '../components/CTA';
import { Footer } from '../components/Footer';

const Leistungen = () => {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="leistungen-page">
      <Navbar />
      {/* Hero glow that extends behind navbar */}
      <div className="hero-glow" />
      <main className="pt-20 relative">
        {/* Header */}
        <section className="py-24 md:py-32 relative overflow-hidden">
          <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-center max-w-3xl mx-auto"
            >
              <span className="text-sm uppercase tracking-widest text-primary font-semibold mb-4 block">
                Unsere Leistungen
              </span>
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-heading font-bold tracking-tight leading-none mb-6" data-testid="leistungen-headline">
                Beratung für{' '}
                <span className="text-primary">Bildungsträger</span>
              </h1>
              <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
                Von der Gründung über die Zulassung bis zur laufenden QM-Betreuung – wir unterstützen Sie in jeder Phase.
              </p>
            </motion.div>
          </div>
        </section>

        <TargetGroups />
        <Services showAll={true} />
        <CTA />
      </main>
      <Footer />
      <div className="noise-overlay" />
    </div>
  );
};

export default Leistungen;
